export const microBlog = (options) => {
	return `https://service.weibo.com/share/share.php
      ?title= %23%e7%b2%be%e5%bd%a9%e7%9a%84%e5%9c%a8%e5%90%8e%e9%9d%a2%23 我在%23%E6%98%8E%E5%9F%BA%E6%91%84%E5%BD%B1%E5%90%8E%E6%9C%9F%E5%A4%A7%E8%B5%9B%23看到  ${options.author}  的作品  《${options.worksname}》，快来为作品助力，选择你的精彩！
      &url=${options.url}
      &pic=${options.pic}?x-oss-process=image/resize,p_10
      `.replace(/\s/g, '');
};
